var _defs, _circle, _path, _use, _path2, _ellipse, _circle2, _path3, _path4, _path5, _path6, _path7, _circle3, _circle4, _circle5, _g, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeBirdie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bg",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EE5A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B92A1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 35 L19 29 L21 38 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 35,
    rx: 13.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23.5,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 20.5 L55 23.5 L47.5 26.5 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 54,
    r: 7
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 44 L26 47.5 M33 44.5 L33.5 47.5",
    stroke: "#0B131E",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#sil",
    fill: "#0B131E",
    stroke: "#0B131E",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 35 L19 29 L21 38 Z",
    fill: "#3D5F87"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 35,
    rx: 13.5,
    ry: 10.5,
    fill: "#5B86B8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23.5,
    r: 9,
    fill: "#5B86B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 27 C40 26.5 45 29 44 33 C42 40 36 45.5 29 45.5 C24 45.5 20 43.5 18.5 40.5 C24 40 30 35 33.5 27 Z",
    fill: "#FCE8CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32 C19 27 27 26 31 29 C30 35 23 38.5 16.5 36.5 Z",
    fill: "#3D5F87",
    stroke: "#0B131E",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 32.5 C22 31.8 25 32 27 33 M20 35 C22 34.8 24 35 25.5 35.5",
    fill: "none",
    stroke: "#8FB0D6",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 20.5 L55 23.5 L47.5 26.5 Z",
    fill: "#F2B01E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8 23.5 H53",
    stroke: "#B7791F",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 21.5,
    r: 2.1,
    fill: "#0B131E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2,
    cy: 20.8,
    r: 0.7,
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 54,
    r: 7,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CBD5E1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 51.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 50.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 52,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 55,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 55.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 57.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 58.5,
    r: 0.9
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "none",
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBirdie);
export default __webpack_public_path__ + "static/media/badge-birdie.135bb3e8a9ee1aa9c0c3fd04f1b49896.svg";
export { ForwardRef as ReactComponent };